/* loaded by smart-asset */
export default require("./loginx1920~SpACMtQf.png")